// extracted by mini-css-extract-plugin
module.exports = {"sectionContainer":"policy_section_sectionContainer__3YDlk"};